import {isValidKey} from "../utils/functions";

declare const FunnelKeyNominality: unique symbol
export type FunnelKey = string & { [FunnelKeyNominality]: never }
declare const RoleKeyNominality: unique symbol
export type RoleKey = string & { [RoleKeyNominality]: never }
declare const ContentKeyNominality: unique symbol
export type ContentKey = string & { [ContentKeyNominality]: never }
export type LineKey = RoleKey | ContentKey;

class _KeyPair {
    private readonly funnel_key: FunnelKey;

    constructor(funnel_key: FunnelKey) {
        this.funnel_key = funnel_key;
    }

    get FunnelKey() {
        return this.funnel_key;
    }

    _equals(cell_key: _KeyPair): boolean {
        return this.funnel_key === cell_key.funnel_key;
    }

    _toString(line_key: string): string {
        return line_key + ':' + this.funnel_key
    }

    static _parseString(key_pair: string): [string, FunnelKey] {
        const parsed = key_pair.split(':', 2);
        if (parsed[0] === undefined || parsed[1] === undefined) {
            throw new Error("invalid key pair string");
        }
        return [parsed[0], parsed[1] as FunnelKey];
    }
}

export class RoleKeyPair extends _KeyPair {
    static readonly __CLASS__ = 'RoleKeyPair';

    private readonly line_key: RoleKey;

    constructor(line_key: RoleKey, funnel_key: FunnelKey) {
        super(funnel_key);
        this.line_key = line_key;
    }

    get LineKey() {
        return this.line_key;
    }

    equals(key_pair: RoleKeyPair): boolean {
        return this.line_key === key_pair.line_key && this._equals(key_pair);
    }

    toString(): string {
        return this._toString(this.line_key);
    }

    static fromString(key_pair: string) {
        const pair = _KeyPair._parseString(key_pair);
        return new RoleKeyPair(pair[0] as RoleKey, pair[1]);
    }
}

export class ContentKeyPair extends _KeyPair {
    static readonly __CLASS__ = 'ContentKeyPair';

    private readonly line_key: ContentKey;

    constructor(line_key: ContentKey, funnel_key: FunnelKey) {
        super(funnel_key);
        this.line_key = line_key;
    }

    get LineKey() {
        return this.line_key;
    }

    equals(key_pair: ContentKeyPair): boolean {
        return this.line_key === key_pair.line_key && this._equals(key_pair);
    }

    toString(): string {
        return this._toString(this.line_key);
    }

    static fromString(key_pair: string) {
        const pair = _KeyPair._parseString(key_pair);
        return new ContentKeyPair(pair[0] as ContentKey, pair[1]);
    }

    static fromJSON(json: any) {
        if (!isValidKey(json.funnel_key)) {
            throw new Error("invalid funnel_key");
        }
        if (!isValidKey(json.line_key)) {
            throw new Error("invalid line_key");
        }

        return new ContentKeyPair(json.line_key, json.funnel_key);
    }

}